'use client'

import clsx from 'clsx'
import { createContext, forwardRef, ReactNode, useContext } from 'react'

import cls from './RadioGroup.module.scss'

interface RadioGroupContextValue {
	value?: string
	onChange?: (value: string) => void
	buttonStyle?: 'solid' | 'outline'
	name?: string
}

const RadioGroupContext = createContext<RadioGroupContextValue | null>(null)

export const useRadioGroup = () => {
	return useContext(RadioGroupContext)
}

interface RadioGroupProps {
	children: ReactNode
	value?: string
	onChange?: (e: { target: { value: string } }) => void
	buttonStyle?: 'solid' | 'outline'
	className?: string
	name?: string
}

export const RadioGroup = forwardRef<HTMLDivElement, RadioGroupProps>(
	({ children, value, onChange, buttonStyle = 'outline', className, name }, ref) => {
		const handleChange = (newValue: string) => {
			onChange?.({ target: { value: newValue } })
		}

		return (
			<RadioGroupContext.Provider value={{ value, onChange: handleChange, buttonStyle, name }}>
				<div ref={ref} className={clsx(cls.radioGroup, className)}>
					{children}
				</div>
			</RadioGroupContext.Provider>
		)
	}
)

RadioGroup.displayName = 'RadioGroup'
